import $rdf from '@zazuko/env/web.js';
import { sh } from '@tpluscode/rdf-ns-builders/loose';
import { isGraphPointer } from 'is-graph-pointer';
import { PatternBuilder } from '../nodeExpression/NodeExpression.js';
export default class TripleRule {
    constructor(subject, predicate, object) {
        this.subject = subject;
        this.predicate = predicate;
        this.object = object;
    }
    static matches(pointer) {
        return isGraphPointer(pointer.out(sh.subject)) &&
            isGraphPointer(pointer.out(sh.predicate)) &&
            isGraphPointer(pointer.out(sh.object));
    }
    static fromPointer(pointer, factory) {
        const subject = pointer.out(sh.subject);
        const predicate = pointer.out(sh.predicate);
        const object = pointer.out(sh.object);
        return new TripleRule(factory.nodeExpression(subject), factory.nodeExpression(predicate), factory.nodeExpression(object));
    }
    buildPatterns({ focusNode, variable, rootPatterns }) {
        const builder = new PatternBuilder();
        const subject = builder.build(this.subject, { subject: focusNode, variable, rootPatterns });
        const predicate = builder.build(this.predicate, { subject: focusNode, variable, rootPatterns });
        const object = builder.build(this.object, { subject: focusNode, variable, rootPatterns });
        return {
            constructClause: [$rdf.quad(subject.object, predicate.object, object.object)],
            whereClause: [
                ...rootPatterns,
                ...subject.patterns,
                ...predicate.patterns,
                ...object.patterns,
            ],
        };
    }
}
